import notResult from "../../assets/images/notResult.svg";
import PageHeading from "./headingsUI/CenteredHeading";

const NoDataDisplay = ({bgColor}) => {
  return (
    <div className={`noDataDisplayContainer ${bgColor && bgColor}`}>
      <img src={notResult} alt="No Result Found" className="mx-auto" />
      <PageHeading title="No data available!" />
    </div>
  );
};
export default NoDataDisplay;
